<template>
  <div>
    <v-select
      :clearable="false"
      :clearSearchOnSelect="false"
      :options="options"
      :searchable="false"
      v-model="selectedCount"
      class="select-pagination"
      @input="changeCount"
    ></v-select>
  </div>
</template>

<script>
export default {
  data() {
    return {
      options: [
        {label: 10, value: 10},
        {label: 25, value: 25},
        {label: 50, value: 50}
      ],
      selectedCount: ''
    }
  },
  methods: {
    changeCount(value) {
      this.$emit('changeCountsOnPage', value.value)
      localStorage.setItem('countsOnPage', JSON.stringify(value))
    }
  },
  created() {
    if (!localStorage.getItem('countsOnPage')) {
      this.selectedCount = this.options[0]
    } else {
      this.selectedCount = JSON.parse(localStorage.getItem('countsOnPage'))
    }
  }
}
</script>

<style lang="scss" scoped>
.select-pagination::v-deep {
  min-width: 80px;
  max-width: 80px;
  margin-right: 10px;
  color: #000;
  & .vs__dropdown-menu {
    top: auto !important;
    bottom: calc(100% - 1px) !important;
    box-shadow: 0px -2px 6px 2px rgba(0, 0, 0, .15) !important;
  }

  & .vs__dropdown-toggle {
    border: none;
    border-radius: 4px;
    background: rgba(255, 255, 255, 0.5);
    height: 50px;
    font-size: 20px;
  }

  & .vs__selected {
    padding-top: 4px;
  }

  & .vs--open .vs__open-indicator {
    fill: rgba(0, 0, 0, .5)
  }
}


</style>